import { takeLatest } from 'redux-saga/effects';
import AT from '../constants/action-types';
import { createControlBox, updateControlBox } from '../api';
import { handleFormSubmit } from './helpers/handle-api-form-call';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* processSaveControlBox(action: any) {
  const { data, formikActions } = action;
  const { id, serviceProviderId } = data;
  yield handleFormSubmit({
    id,
    formikActions,
    updateFn: async () => updateControlBox(id, { serviceProviderId, ...data }),
    createFn: async () => createControlBox({ serviceProviderId, ...data })
  });
}

export default function* saveControlBoxSaga() {
  yield takeLatest(AT.SAVE_CONTROL_BOX_SAGA, processSaveControlBox);
}
